export default "__VITE_ASSET__Cvv8Ckze__"